<template>
  <div>
    <div v-html="$t('floor.description')" />
    <item-block
      class="cy-room-floor-block"
      :id="'room-floor-' + room.id"
      v-for="(room, i) in $store.state.rooms"
      :key="'room-floor-' + room.id"
    >
      <RoomFloorOptions :room="room" @input="onRoomInput(i, $event)" :for-title="forTitle(room)" />
    </item-block>
  </div>
</template>

<script>
import RoomFloorOptions from "../../room/RoomFloorOptions";

export default {
  components: {
    RoomFloorOptions,
  },
  methods: {
    onRoomInput(roomIndex, updatables) {
      this.$store.dispatch("setRoom", {
        roomIndex,
        updatables,
      });
    },

    forTitle(room) {
      const size = room.size;
      const title = room.title.toLowerCase();
      return this.$t(`for ${title}`) + ` (${size} m²)`;
    },

    roomTitle(room) {
      const length = this.$store.state.rooms.length;

      if (length <= 1) {
        return this.$t("Choose floor");
      }

      const forTitle = this.forTitle(room);

      if (length === 2) {
        return this.$t("Choose floor {0}", [forTitle]);
      }

      const identificator = room.size ? room.size + "m²" : room.index ? room.index : "";

      return this.$t("Choose floor {0}", [`${forTitle} ${identificator}`]);
    },
  },
};
</script>
